import React, { useEffect, useState } from 'react';
import { Container, StyledForm } from './styles';

const StickyMobileForm = ({ inlineMarketingForm }) => {
  const [showForm, toggleShowForm] = useState(false);
  const [hide, setHide] = useState(false);

  const handleScroll = e => {
    const bodyOffset = document.body.getBoundingClientRect();

    bodyOffset.top < -452 ? toggleShowForm(true) : toggleShowForm(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <Container showForm={showForm}>
      <StyledForm
        inlineMarketingForm={hide ? null : inlineMarketingForm}
        showPrivacy={false}
        label={null}
        title={null}
        onSuccess={() => {
          setHide(true);
        }}
      />
    </Container>
  );
};

export default StickyMobileForm;
